import React, { Fragment } from "react"

const LessonView = (props: any) => {
  const {
    isLast,
    isFirst,
    sn,
    noOfItems,
    lesson,
    moveToNext,
    moveToPrev,
    startQuestions,
  } = props

  const media = lesson?.mediaURL || lesson?.media_url
  return (
    <Fragment key={sn}>
      <header className="p-5 bg-kyzzen-secondary rounded-x10 text-xl font-medium">
        <span className="text-accent-main">
          Lesson {sn}/{noOfItems}:
        </span>{" "}
        {lesson?.title}
      </header>
      <div className="p-5 rounded-x10 rounded-t-none mt-2">
        <p className="max-h-72 overflow-y-auto" dangerouslySetInnerHTML={{ __html: lesson?.text.replaceAll("\n", '<br/>') }}></p>
        {
          (
            media?.toLowerCase().includes('image') || (
              media?.toLowerCase().includes('.png') ||
              media?.toLowerCase().includes('.jpg') ||
              media?.toLowerCase().includes('.jpeg') ||
              media?.toLowerCase().includes('.gif'))
          ) ?
            <div className="w-full rounded-md mt-5"
              style={{
                backgroundImage: `url(${media})`,
                backgroundPosition: `center`,
                backgroundSize: `cover`,
                height: "400px"
              }}
            >
            </div> :
            <div >
              <video controls id="video-tag">
                <source id="video-source" src={media} key={sn} />
                Your browser does not support the video tag.
              </video>
            </div>
        }

        <div className="flex items-center gap-5 relative z-5 pt-5">
          {!isFirst && (
            <button
              className="gradient-outline-btn hover-gradient-text rounded-x10 flex-1 p-2.5"
              onClick={moveToPrev}
            >
              <span>Back</span>
            </button>
          )}
          <button
            className={`bg-gradient text-kyzzen-secondary rounded-x10 font-medium flex-1 p-2.5 w-full`}
            onClick={isLast ? startQuestions : moveToNext}
          >
            {isLast ? "Take Test" : "Next"}
          </button>
        </div>
      </div>
    </Fragment>
  )
}

export default LessonView
